export const ACCT_POSTAL_CODE_LOGIN_INITIATE =
  'ACCT_POSTAL_CODE_LOGIN_INITIATE';

import { AccountPostalCodePayload } from '@src/app/login/types';

export type Actions = {
  ACCT_POSTAL_CODE_LOGIN_INITIATE: {
    type: typeof ACCT_POSTAL_CODE_LOGIN_INITIATE;
    payload: AccountPostalCodePayload;
  };
};

// Action Creators
export const actionCreators = {
  accountPostalCodeLogin: (
    payload: AccountPostalCodePayload,
  ): Actions[typeof ACCT_POSTAL_CODE_LOGIN_INITIATE] => ({
    type: ACCT_POSTAL_CODE_LOGIN_INITIATE,
    payload,
  }),
};
